<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height">
        <router-view/>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default { name: 'AuthLayout' };
</script>

<style lang="scss" scoped>
.fill-height {
  min-height: 100vh;
  background: linear-gradient(135deg, $auth-gradient-start 0%, $auth-gradient-end 100%);
}

.container {
  background-color: $light-surface-1;
  background-image: url('./../assets/background-pattern.png');
  background-repeat: no-repeat;
}
</style>
